import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  IAIGenerationContentResp,
  IAIGenerateContentDto,
  IWebChatbotDto,
  IWebChatbotHistoryResp,
  IMessageResponseDto,
} from 'src/types'

class AIGenerationDataService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getGeneratedDescription(dto: IAIGenerateContentDto) {
    return this.post<IAIGenerationContentResp, IAIGenerateContentDto>(`ai-generation/content`, dto)
  }

  getAvailableModels() {
    return this.get<string[]>(`ai-generation/models`)
  }

  getUserChatBotHistory() {
    return this.get<IWebChatbotHistoryResp[]>(`ai-generation/chatbot`)
  }

  generateUserChatBotResponse(dto: IWebChatbotDto) {
    return this.post<IWebChatbotHistoryResp, IWebChatbotDto>(`ai-generation/chatbot`, dto)
  }

  clearUserChatHistory() {
    return this.put<IMessageResponseDto, {}>(`ai-generation/chatbot/clear`, {})
  }
}

const AIGenerationService = new AIGenerationDataService()

export default AIGenerationService
